import React from 'react';
import { FEATURE_ID } from '../../../Common/constant';
import AfterSalesIcon from "../../../assets/images/service/after-sales-service.png";
import ConsultingIcon from "../../../assets/images/service/consulting.png";
import ITConsultantIcon from "../../../assets/images/service/it-consultant.png";
import TechnicalSupportIcon from "../../../assets/images/service/technical-support.png";
import TrainingIcon from "../../../assets/images/service/training.png";

const Service = () => {
    const services = [
        {
            id: "after-sales-service",
            title: "After Sales Service",
            icon: AfterSalesIcon,
            data_aos_delay: '800ms',
        },
        {
            id: "technical-support",
            title: "Technical Support",
            icon: TechnicalSupportIcon,
            data_aos_delay: '400ms',
        },
        {
            id: "consulting",
            title: "Consulting",
            icon: ConsultingIcon,
            data_aos_delay: '600ms',
        },
        {
            id: "training",
            title: "Training",
            icon: TrainingIcon,
            data_aos_delay: '200ms',
        },
        {
            id: "it-consultant",
            title: "IT Consultant",
            icon: ITConsultantIcon,
            data_aos_delay: '0ms',
        },
    ]

    return (
        <section id={FEATURE_ID.SERVICE} className="service__section p_relative see__pad">
            <div className="auto-container">
                <div className="service__data">
                    <div className="title__data">
                        <div className="title">
                            <h2>Explore Our Services</h2>
                        </div>
                    </div>
                    <div className="new__service__block__wrapper">
                        {services.map((item) => (
                            <div className="wow fadeInUp animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms" key={item.id}>
                                <div className="product__block">
                                    <div className="product__icon">
                                        <img src={item.icon} alt={item.icon} />
                                    </div>
                                    <div className="product__text">
                                        <button><h4>{item.title}</h4></button>
                                    </div>
                                </div>
                            </div>
                        )
                        )}
                    </div>
                    {/* <div className="row">
                        {services.map((item, id) => (
                            <div className="col-lg-4 col-sm-12 wow fadeInUp animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms" key={id}>
                                <div className="service__block">
                                    <div className="service__icon">
                                        <img src={item.icon} alt={item.icon} />
                                    </div>
                                    <div className="service__text">
                                        <h4>{item.title}</h4>
                                        <p>{item.description}</p>
                                    </div>
                                </div>
                            </div>
                        )
                        )}
                    </div> */}
                </div>
            </div>
        </section>
    );
}

export default Service